<template>
  <v-container
    fluid
    class="order"
    :class="{ mobile: $vuetify.breakpoint.mobile }"
    v-if="supplierOrder"
  >
    <v-row class="ml-0">
      <v-col class="order-info px-0">
        <div class="font-weight-bold">Order # {{ supplierOrder.number }}</div>
        <div v-if="supplierOrder.user">
          {{ supplierOrder.user.firstName + supplierOrder.user.lastName }}
        </div>
        <!-- <div>0723 8975 3945</div> -->
      </v-col>
    </v-row>

    <v-row
      class="order-content mb-4 mx-0 px-0"
      v-for="item in supplierOrder.items"
      :key="item.number"
    >
      <v-col cols="12" class="supplier-order">
        <div
          class="d-flex align-center"
          :class="{
            'justify-center': $vuetify.breakpoint.xsOnly,
            'justify-space-between': $vuetify.breakpoint.smAndUp
          }"
        >
          <h2 class="text-decoration-underline pl-4">
            Supplier order #{{ supplierOrder.number }} <br />
            Sold by {{ supplierOrder.supplier.name }}
          </h2>
          <v-img
            v-if="$vuetify.breakpoint.smAndUp"
            class="flex-grow-0 mr-2"
            width="36"
            height="36"
            :src="supplierOrder.logo"
          ></v-img>
        </div>
      </v-col>
      <v-col cols="12" v-if="$vuetify.breakpoint.smAndUp">
        <v-divider horizontal></v-divider>
      </v-col>

      <v-col cols="12 pa-3" v-if="$vuetify.breakpoint.mobile && false">
        <div
          class="order-item"
          v-for="(orderItem, index) in supplierOrder.items"
          :key="index"
        >
          <div class="order-product-images">
            <v-carousel
              hide-delimiters
              :show-arrows="orderItem.images.length > 1"
              height="114"
              v-model="carousel"
              v-if="orderItem.images.length > 0"
            >
              <v-carousel-item
                v-for="image in orderItem.images"
                :key="image.id"
                :src="image.imageUrl"
              ></v-carousel-item>
            </v-carousel>
            <v-carousel
              hide-delimiters
              :show-arrows="false"
              height="114"
              v-model="carousel"
              v-else
            >
              <v-carousel-item
                src="https://i.stack.imgur.com/y9DpT.jpg"
              ></v-carousel-item>
            </v-carousel>
          </div>
          <div class="order-info">
            <div class="order-header">
              <div class="order-title">{{ orderItem.name }}</div>
              <v-img
                class="flex-grow-0"
                width="25"
                height="25"
                :src="orderItem.brand.logo"
              ></v-img>
            </div>
            <div class="order-desc mt-2">
              <span>{{
                orderItem.description.length > 50
                  ? orderItem.description.substring(0, 50)
                  : orderItem.description
              }}</span>
              <span
                v-if="orderItem.description.length > 50"
                @click="openDescription(orderItem.description)"
                class="font-16 appGreen--text pointer"
              >
                ....
              </span>
            </div>
            <div class="order-price">
              <div class="d-flex justify-space-between">
                <div>Quantity:</div>
                <div>{{ orderItem.quantity }}</div>
              </div>
              <div class="d-flex justify-space-between">
                <div>Price:</div>
                <div>£{{ orderItem.amount }}</div>
              </div>
              <div class="d-flex justify-space-between">
                <div>Total:</div>
                <div>
                  £{{ (orderItem.amount * orderItem.quantity).toFixed(2) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>

      <v-col cols="12 pa-3" v-if="$vuetify.breakpoint.smAndUp">
        <v-row v-for="(orderItem, index) in supplierOrder.items" :key="index">
          <v-col cols="3">
            <v-carousel
              hide-delimiters
              :show-arrows="orderItem.images.length > 1"
              height="296"
              v-model="carousel"
              v-if="orderItem.images.length > 0"
            >
              <v-carousel-item
                v-for="image in orderItem.images"
                :key="image.id"
                :src="image.imageUrl"
              ></v-carousel-item>
            </v-carousel>
            <v-carousel
              hide-delimiters
              :show-arrows="false"
              height="130"
              v-model="carousel"
              v-else
            >
              <v-carousel-item
                src="https://i.stack.imgur.com/y9DpT.jpg"
              ></v-carousel-item>
            </v-carousel>
          </v-col>
          <v-col cols="4">
            <h2 class="header">{{ orderItem.name }}</h2>
            <div class="body-2 mt-4">
              {{
                orderItem.description.length > 94
                  ? orderItem.description.substring(0, 90)
                  : orderItem.description
              }}
              <span
                v-if="orderItem.description.length > 94"
                @click="openDescription(orderItem.description)"
                class="font-16 appGreen--text pointer"
              >
                ....
              </span>
            </div>
          </v-col>
          <v-col cols="5" class="pr-8">
            <div
              class="d-flex justify-space-between body-2 flex-wrap text-right"
            >
              <div class="flex-3 font-bold mb-3">Quantity</div>
              <div class="flex-3 font-bold mb-3">Price</div>
              <div class="flex-3 font-bold mb-3">Total</div>
              <!-- </div>
            <div
              class="mt-10 d-flex justify-space-between text-right body-2 font-weight-bold"
            > -->
              <div class="flex-3">{{ orderItem.quantity }}</div>
              <div class="flex-3">
                {{ orderItem.currency | currencySymbol }}{{ orderItem.amount }}
              </div>
              <div class="flex-3">
                £{{ (orderItem.amount * orderItem.quantity).toFixed(2) }}
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12">
        <div class="checkout-panel order-checkout-panel">
          <v-col cols="12" class="pl-sm-5">
            <v-row class="justify-end">
              <v-col
                class="order-cost"
                cols="12"
                v-if="$vuetify.breakpoint.xsOnly"
              >
                <div class="d-flex justify-space-between">
                  <div>Subtotal</div>
                  <div>
                    {{ supplierOrder.price.currency | currencySymbol
                    }}{{ supplierOrder.price.subTotal }}
                  </div>
                </div>
                <div class="d-flex justify-space-between">
                  <div>Shipping</div>
                  <div>
                    {{ supplierOrder.price.currency | currencySymbol
                    }}{{ supplierOrder.price.shippingFee }}
                  </div>
                </div>
                <div class="d-flex justify-space-between">
                  <div>Discount</div>
                  <div>
                    {{ supplierOrder.price.currency | currencySymbol
                    }}{{ supplierOrder.price.discount }}
                  </div>
                </div>
              </v-col>
              <div
                v-if="$vuetify.breakpoint.xsOnly"
                class="d-flex justify-space-between flex-grow-1 order-total"
              >
                <div>Total</div>
                <div>
                  {{ supplierOrder.price.currency | currencySymbol
                  }}{{
                    supplierOrder.price.subTotal +
                      supplierOrder.price.shippingFee +
                      supplierOrder.price.discount
                  }}
                </div>
              </div>
              <v-col
                v-if="$vuetify.breakpoint.smAndUp"
                cols="12"
                sm="12"
                md="4"
                class="cost-panel mb-3"
              >
                <v-row class="pr-4">
                  <v-col cols="9">
                    <span>Sub Total</span>
                  </v-col>
                  <v-col cols="3">
                    <span
                      >{{ supplierOrder.price.currency | currencySymbol
                      }}{{ supplierOrder.price.subTotal }}</span
                    >
                  </v-col>
                </v-row>
                <v-row class="pr-4">
                  <v-col cols="9">
                    <span>Shipping</span>
                  </v-col>
                  <v-col cols="3">
                    <span
                      >{{ supplierOrder.price.currency | currencySymbol
                      }}{{ supplierOrder.price.shippingFee }}</span
                    >
                  </v-col>
                </v-row>
                <v-row class="pr-4">
                  <v-col cols="9">
                    <span>Discount</span>
                  </v-col>
                  <v-col cols="3">
                    <span
                      >{{ supplierOrder.price.currency | currencySymbol
                      }}{{ supplierOrder.price.discount }}</span
                    >
                  </v-col>
                </v-row>
                <v-row class="pr-4">
                  <v-col cols="9">
                    <span>Total</span>
                  </v-col>
                  <v-col cols="3">
                    <span
                      >{{ supplierOrder.price.currency | currencySymbol
                      }}{{
                        supplierOrder.price.subTotal +
                          supplierOrder.price.shippingFee +
                          supplierOrder.price.discount
                      }}</span
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </div>
      </v-col>
    </v-row>

    <v-row
      class="checkout-panel mt-5 mx-3 mx-md-0"
      v-if="$vuetify.breakpoint.xsOnly"
    >
      <v-col cols="12" class="px-0 mx-0">
        <div class="d-flex">
          <v-img src="@/assets/guarantee.svg" width="25" height="25"></v-img>
          <p>Shop with ease with out 14 Day Monkey Back Gurantee</p>
        </div>
        <div class="order-cost" v-if="supplierOrder.price">
          <div class="d-flex justify-space-between">
            <div>Subtotal</div>
            <div>
              {{ supplierOrder.price.currency | currencySymbol
              }}{{ supplierOrder.price.subTotal }}
            </div>
          </div>
          <div class="d-flex justify-space-between">
            <div>Shipping</div>
            <div>
              {{ supplierOrder.price.currency | currencySymbol
              }}{{ supplierOrder.price.shippingFee }}
            </div>
          </div>
          <div class="d-flex justify-space-between">
            <div>Discount</div>
            <div>
              {{ supplierOrder.price.currency | currencySymbol
              }}{{ supplierOrder.price.discount }}
            </div>
          </div>
          <div class="d-flex justify-space-between">
            <div>Total</div>
            <div>{{ supplierOrder.price.total }}</div>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row
      class="checkout-panel mt-5 mb-10 mx-0 px-0"
      v-if="$vuetify.breakpoint.smAndUp"
    >
      <v-col cols="12" v-if="supplierOrder.price">
        <v-row class="justify-end">
          <v-spacer></v-spacer>
          <v-col cols="12" sm="12" md="6" class="cost-panel pt-4">
            <v-row>
              <v-col cols="10">
                <span>Sub Total</span>
              </v-col>
              <v-col cols="2">
                <span
                  >{{ supplierOrder.price.currency | currencySymbol
                  }}{{ supplierOrder.price.subTotal }}</span
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="10">
                <span>Shipping</span>
              </v-col>
              <v-col cols="2">
                <span
                  >{{ supplierOrder.price.currency | currencySymbol
                  }}{{ supplierOrder.price.shippingFee }}</span
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="10">
                <span>Discount</span>
              </v-col>
              <v-col cols="2">
                <span
                  >{{ supplierOrder.price.currency | currencySymbol
                  }}{{ supplierOrder.price.discount }}</span
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="9" class="guarantee">
            <v-img src="@/assets/guarantee.svg"></v-img>
            <p>Shop with ease with out 14 Day Monkey Back Gurantee</p>
          </v-col>
          <v-col cols="12" sm="12" md="3" class="total my-3">
            <v-row>
              <v-col cols="8">
                <span>Total</span>
              </v-col>
              <v-col cols="4">
                <span>{{ supplierOrder.price.total }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import helpers from "@/mixins/helpers.js";

export default {
  name: "OrderComponent",
  props: ["supplierId", "id"],
  mixins: [helpers],
  filters: {
    currencySymbol: function(value) {
      let symbols = {
        USD: "$", // US Dollar
        EUR: "€", // Euro
        CRC: "₡", // Costa Rican Colón
        GBP: "£", // British Pound Sterling
        ILS: "₪", // Israeli New Sheqel
        INR: "₹", // Indian Rupee
        JPY: "¥", // Japanese Yen
        KRW: "₩", // South Korean Won
        NGN: "₦", // Nigerian Naira
        PHP: "₱", // Philippine Peso
        PLN: "zł", // Polish Zloty
        PYG: "₲", // Paraguayan Guarani
        THB: "฿", // Thai Baht
        UAH: "₴", // Ukrainian Hryvnia
        VND: "₫" // Vietnamese Dong
      };
      return symbols[value];
    }
  },
  computed: mapState({
    supplierOrder: state => state.supplierorders.supplierOrder,
    countries: state => state.countries.countries
  }),
  data: () => ({
    showShippingEditModal: false,
    page: 1,
    totalVisible: 6,
    length: 10,
    shipment: {},
    carousel: 1,
    buildingNoRules: [
      v => !!v || "Building no is required",
      v => (v && v.length >= 3) || "Building no must be at least 3 characters",
      v =>
        (v && v.length <= 20) ||
        "Building no must be less than than 20 characters"
    ],
    addressRules: [
      v => !!v || "Address is required",
      v => (v && v.length >= 10) || "Address must be at least 10 characters",
      v =>
        (v && v.length <= 100) ||
        "Address must be less than than 100 characters"
    ],
    cityRules: [
      v => !!v || "City is required",
      v => (v && v.length >= 4) || "City must be at least 4 characters",
      v => (v && v.length <= 35) || "City must be less than than 35 characters"
    ],
    stateRules: [
      v => !!v || "State is required",
      v => (v && v.length >= 4) || "State must be at least 4 characters",
      v => (v && v.length <= 25) || "State must be less than than 25 characters"
    ],
    countryRules: [v => !!v || "Country is required"]
  }),
  async mounted() {
    await this.$store.dispatch("supplierorders/LOAD_SUPPLIER_ORDER", {
      supplierId: this.supplierId,
      id: this.id
    });
    this.$store.dispatch("countries/LOAD_COUNTRIES", {
      from: 0,
      to: 0
    });
    this.shipment = Object.assign({}, this.supplierOrder.shipment);
  },
  methods: {
    async updateShippingAddress() {
      if (this.$refs.shipmentUpdateForm.validate()) {
        this.$swal({
          title: "Updating shipment address",
          html: "This will only take a moment",
          icon: "info",
          onOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store
          .dispatch("orders/UPDATE_SHIPPING_ADDRESS", this.shipment)
          .then(() => {
            this.$swal({
              title: "Success",
              html: "Shipment address updated successfully",
              icon: "info"
            });
          })
          .catch(err => {
            this.$swal({
              title: "Failed",
              html: err,
              icon: "info"
            });
          });
        this.supplierOrder.shipment = Object.assign({}, this.shipment);
        this.showShippingEditModal = false;
      }
    },
    openShippingEditModal() {
      this.showShippingEditModal = true;
    },
    getNumbers(start, stop) {
      return new Array(stop - start).fill(start).map((n, i) => n + i);
    },
    openDescription(description) {
      this.$swal.fire({
        html: description
      });
    }
  }
};
</script>
<style lang="scss">
.orders {
  .v-input {
    .v-label,
    input {
      font-size: 14px;
    }
  }
}
.flex-3 {
  flex: 0 0 33.333333%;
}
</style>
<style scoped lang="scss" src="./Order.scss"></style>
